// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sffo3YHXbT8aCjfrh09D{background:var(--gray-20);cursor:pointer;border-radius:6px;height:6px}.VFqkfUG7GUA7PKu2UqC3{background:var(--background-brand-default);border-radius:6px;height:6px;transition:width .1s}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"range": `sffo3YHXbT8aCjfrh09D`,
	"bar": `VFqkfUG7GUA7PKu2UqC3`
};
export default ___CSS_LOADER_EXPORT___;
